import React from 'react';
import styled from "styled-components";
import { ReactComponent as InfoAmb } from '../../resources/images/infoiconamb.svg';

const ContentDividerTitle = styled.h2`
    color: ${props => props.theme.headerColor || '#6B207D'};
`
const InfoAmbIcon = styled(InfoAmb)`
    fill: ${props => props.theme.buttonBackground || '#6B207D'};
`;

const ContentDividerWithIcon = ({hidden, icon, title, text, iconSize}) => {
    const getIcon = (icon) => {
        switch (icon) {
            default:
                return <InfoAmbIcon/>
        }
    }

    if(hidden) {
        return false;
    }
    return (
        <div className="mt-4 mb-4 py-4 bg-primary-lightest text-primary flex items-center">
            <div className={`align-middle mx-4 fill-current inline-block content-icon ${iconSize === "medium" ? "w-6 h-6" : "w-8 h-8"}`}>
                { getIcon(icon) }
            </div>
            { title &&
                <ContentDividerTitle className="align-middle inline-block m-0 text-xl">
                    {title}
                </ContentDividerTitle>
            }
            { text &&
                <p className="align-middle inline-block m-0 mr-4">{text}</p>
            }
        </div>
    );
}

export default ContentDividerWithIcon;